import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Menu from "react-burger-menu/lib/menus/slide";
import "./SlideNav.css";
import { metadataService, userService, ProfileApi } from "../_services";
import {registrationActions, newLoanActions, refinanceIncreaseLoanActions, userActions, profileActions} from "../_actions";
import { Button } from 'reactstrap';
import globe from './images/SL-Application_navigation-globalicon.svg';
import burger from './images/hamburger.svg';
import { history } from "../_helpers";

class SlideNav extends Component {
  static displayName = SlideNav.name;

  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
      language: "",
    };

    this.newLoanDispatch = this.newLoanDispatch.bind(this);
    this.toggleLanguage = this.toggleLanguage.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }
  componentDidMount() {
    this.setState({
      language: userService.getUserLanguage(),
    });
  }

  handleStateChange(state) {
    this.setState({
      menuOpen: state.isOpen, 
    });
  }

  closeMenu() {
    this.setState({ menuOpen: false });
  }
  openMenu() {
    this.setState({ menuOpen: true });
  }

  newLoanDispatch = (e) => {
    e.preventDefault();

    const { dispatch } = this.props;

    if (!userService.getCurrentUser()) {
      dispatch(registrationActions.handleNewLoanMenuClick());
    } else {
      dispatch(newLoanActions.handleNewLoanMenuClick());
    }

    this.closeMenu();
  };

  refinanceDispatch = (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch(refinanceIncreaseLoanActions.handleRefinanceMenuClick());
    this.closeMenu();
  };
  navigateToSecureUpload = (e) => {
    e.preventDefault();
    this.closeMenu();
    history.push("/secure-upload");
  }

  toggleMenu() {
    this.setState((state) => ({ menuOpen: !state.menuOpen }));
  }

  toggleLanguage() {
    this.props.actions.updateAppLanguage();
  }

  render() {
    const { isMyDocumentsEnabled , language, savingExtendedProfile } = this.props;
    return (
      <div className="navContainer">
        <div>
          <div style={{ position: "absolute", right: "80px" }}>
            <Button
              name={language === userService.LANGUAGES.EN || "" ? "Espanol" : "English"}
              outline
              className="bm-language"
              size="md"
              onClick={this.toggleLanguage}
              disabled={savingExtendedProfile===true}
            >
              <img src={globe} alt="Globe" loading="eager" data-skip-lazy />{" "}
              &nbsp;{" "}
              {metadataService.getButton(
                language === userService.LANGUAGES.EN || "" ? "Espanol" : "English"
              )}
            </Button>
          </div>
          {!userService.getCurrentUser() && (
            <div>
              <Menu
                right
                disableAutoFocus
                isOpen={this.state.menuOpen}
                onOpen={this.openMenu}
                onClose={this.closeMenu}
                onStateChange={(state) => this.handleStateChange(state)}
                customBurgerIcon={<img src={burger} />}
              >
                <Link
                  id="login"
                  onClick={() => this.closeMenu()}
                  to="/LogInMain"
                >
                  {metadataService.getMenu("LogIn")}
                </Link>
                <Link
                  id="register"
                  onClick={() => this.closeMenu()}
                  to="/SignUpCustomerStatus"
                >
                  {metadataService.getMenu("Register")}
                </Link>
                <Link id="requestNewLoan" onClick={this.newLoanDispatch} to="/">
                  {metadataService.getMenu("RequestNewLoan")}
                </Link>                 
              </Menu>
            </div>
          )}
          {userService.getCurrentUser() &&
            !userService.userHasProblemFlags() && (
              <Menu
                right
                disableAutoFocus
                isOpen={this.state.menuOpen}
                onOpen={this.openMenu}
                onClose={this.closeMenu}
                onStateChange={(state) => this.handleStateChange(state)}
                customBurgerIcon={<img src={burger} />}
              >
                <Link
                  id="myAccount"
                  onClick={() => this.closeMenu()}
                  to="/my-account"
                >
                  {metadataService.getMenu("MyAccount")}
                </Link>
                {isMyDocumentsEnabled && (
                  <Link
                    id="myDocuments"
                    onClick={() => this.closeMenu()}
                    to="/my-documents"
                  >
                    {metadataService.getMenu("MyDocuments")}
                  </Link>
                )}
                <Link
                  id="myProfile"
                  onClick={() => this.closeMenu()}
                  to="/my-profile"
                >
                  {metadataService.getMenu("MyProfile")}
                </Link>
                {this.props.accountViews &&
                  this.props.accountViews.showNewLoanRequest &&
                  this.props.accountViews.isInactiveAccount !== true && (
                    <Link
                      id="requestNewLoan"
                      onClick={this.newLoanDispatch}
                      to="/"
                    >
                      {metadataService.getMenu("RequestNewLoan")}
                    </Link>
                  )}
                {this.props.accountViews &&
                  this.props.accountViews.showIncreaseRefinance && (
                    <Link
                      id="increaseRefinance"
                      onClick={this.refinanceDispatch}
                      to="/"
                    >
                      {metadataService.getMenu("IncreaseRefinance")}
                    </Link>
                  )}               
                {this.props.accountViews &&
                  this.props.accountViews.hasLoans === true && (
                    <Link
                      id="secureUpload"
                      onClick={this.navigateToSecureUpload}
                      to="/"
                    >
                      {metadataService.getMenu("SecureUpload")}
                    </Link>
                  )}               
                <Link
                  id="logout"
                  onClick={() => this.closeMenu()}
                  to="/log-out"
                >
                  {metadataService.getMenu("LogOut")}
                </Link>
              </Menu>
            )}

          {userService.getCurrentUser() &&
            userService.userHasProblemFlags() && (
              <Menu
                right
                disableAutoFocus
                isOpen={this.state.menuOpen}
                onOpen={this.openMenu}
                onClose={this.closeMenu}
                onStateChange={(state) => this.handleStateChange(state)}
                customBurgerIcon={<img src={burger} />}
              >
                
                <Link
                  id="logout"
                  onClick={() => this.closeMenu()}
                  to="/log-out"
                >
                  {metadataService.getMenu("LogOut")}
                </Link>
              </Menu>
            )}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
      accountViews: state.loanInfo.accountViews,
      language: state.users.language,
      isMyDocumentsEnabled : state.documents.isMyDocumentsEnabled,
      loggedIn : state.authentication.loggedIn,      
      savingExtendedProfile : state.profile.savingExtendedProfile,
  };
}
function mapDispatchToProps(dispatch) {
  return {
      dispatch,
      actions: {
          updateAppLanguage: () => {
              dispatch(userActions.updateAppLanguage())
          },
          saveToggleSelectedLanguage:  () => {
            dispatch(profileActions.saveToggleSelectedLanguage())
          }, 
      }
  };
}

const connectedNav = connect(mapStateToProps, mapDispatchToProps)(SlideNav);

export { connectedNav as SlideNav };
